import { formatToCurrency } from '@/lib/helpers';
import { ToWords } from 'to-words';
const toWords = new ToWords({ localeCode: 'en-US' });

export const generatePowerOfAttorney = ({ company, loan, branch, useJP, witnessName, witnessAddress, witnessParish }) => {
  const accountNumber = loan.account.mainAccountNumber;
  const companyName = company.name.toUpperCase();
  const totalLoan = formatToCurrency(loan.loanAmount || 0);
  const totalLoanInWords = toWords
    .convert(loan.loanAmount || 0, { currency: true, doNotAddOnly: true })
    .toUpperCase();
  const motorVehicleCollaterals = loan.loanCollaterals
    .filter((lc) => lc.collateralType === "Motor Vehicle").map(el => 
    ({
        margin: [0, 5, 0, 15],
        table: {
          widths: ['*', '*'],
          body: [
            [
              {
                text: 'Make /Model:',
                bold: false
              },
              {
                text: `${el.make_model}`,
                bold: false
              }
            ],
            [
              {
                text: 'Year:',
                bold: false
              },
              {
                text: `${el.year}`,
                bold: false
              }
            ],
            [
              {
                text: 'Colour:',
                bold: false
              },
              {
                text: `${el.color}`,
                bold: false
              }
            ],
            [
              {
                text: 'Chassis No.:',
                bold: false
              },
              {
                text: `${el.chassis_number}`,
                bold: false
              }
            ],
            [
              {
                text: 'Engine No.:',
                bold: false
              },
              {
                text: `${el.engine_number}`,
                bold: false
              }
            ]
          ]
        },
        layout: {
          // default border settings
          hLineWidth: function(i, node) {
            return (i === 0 || i === node.table.body.length) ? 0.5 : 0.5;
          },
          vLineWidth: function(i, node) {
            return (i === 0 || i === node.table.widths.length) ? 0.5 : 0.5;
          },
          hLineColor: function(i, node) {
            return (i === 0 || i === node.table.body.length) ? 'black' : 'gray';
          },
          vLineColor: function(i, node) {
            return (i === 0 || i === node.table.widths.length) ? 'black' : 'gray';
          },
        }
      })
    ) || [];

  const externalSignatureClause = [
    {
      text: `${companyName}`,
      alignment: 'center',
      margin: [0, 0, 0, 20]
    },
    {
      text: [ 
        'IN WITNESS WHEREOF I/We the said have hereunto set my/our hand(s) and seal this',
        {
          text: 'ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤ',
          margin: [0, 0, 0, 10],
          decoration: 'underline'
        },
        'day of',
        { 
          text: 'ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤ',
          decoration: 'underline'
        },
        ' 20 ',
        { 
          text: 'ㅤㅤㅤㅤㅤ',
          decoration: 'underline'
        },
      ],
      margin: [0, 0, 0, 20]
    }
  ];

  const internalSignatureClause = [
    {
      text: `${companyName}`,
      alignment: 'center',
      margin: [0, 0, 0, 20]
    },
    {
      text: [
        'IN WITNESS WHEREOF I/We the said have hereunto set my/our hand(s) and seal this',
        {
          text: 'ㅤㅤㅤ',
          decoration: 'underline'
        },
        'day of',
        {
          text: 'ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤ',
          decoration: 'underline'
        },
        '20',
        {
          text: 'ㅤㅤㅤ',
          decoration: 'underline'
        }
      ],
      margin: [0, 0, 0, 20]
    },
    {
      text: `I ${witnessName} of ${witnessAddress} in the Parish of ${witnessParish} being duly sworn make oath and say as follows:`,
      margin: [0, 0, 0, 10]
    },
    {
      ol: [
        [
          {
            text: [
              'That within Indenture made Between of the One Part and COK SODALITY CO-OPERATIVE CREDIT UNION LIMITED, of the Other Part being an assignment of personal property by the said was made and delivered on the day it bears date namely the', 
              {
                text:'ㅤㅤㅤ',
                decoration: 'underline'
              },
              'day of',
              {
                text:'ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤ',
                decoration: 'underline'
              },
              '20',
              {
                text: 'ㅤㅤㅤ',
                decoration: 'underline'
              }
            ],
            margin: [0, 0, 0, 20]
          }
        ],
        [
          {
            text: [
              'That I was present and saw the said whose name(s) is/are subscribed in the said Indenture sign, seal and as and for his/her/their proper act and deed deliver the same at',
              {
                text: 'ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤ',
                decoration: 'underline'
              },
              'o’clock in the',
              {
                text: 'ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤ',
                decoration: 'underline'
              },
              'noon on the',
              {
                text: 'ㅤㅤㅤ',
                decoration: 'underline'
              },
              ' day of',
              {
                text: 'ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤ',
                decoration: 'underline'
              },
              '20',
              {
                text: 'ㅤㅤ',
                decoration: 'underline'
              },
              ` at ${witnessAddress} in the parish of ${witnessParish} and that the said`
            ],
            margin: [0, 0, 0, 20]
          }
        ],
        [
          {
            text: [
              `That the name of ${witnessName} subscribing as a witness to the due execution of the said indenture is of the proper handwriting of me this Deponent and I am a`,
              {
                text: 'ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤ',
                decoration: 'underline'
              },
              `residing at ${witnessAddress} in the Parish of ${witnessParish}`
            ],
            margin: [0, 0, 0, 20]
          }
        ]
      ]
    },
    {
      table: {
        widths: ['*','*'],
        body: [
          [
            `SWORN to at ${witnessName}`,
            {
              text: '',
              margin: [0, 0, 0, 20]
            }
          ],
          [
            `in the Parish of ${witnessParish}`,
            {
              text: '',
              margin: [0, 0, 0, 20]
            }
          ],
          [
            {
              text: [
                'this',
                {
                  text: 'ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤ',
                  decoration: 'underline'
                },
                'day of',
                {
                  text: 'ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤ',
                  decoration: 'underline'
                },
                '20',
                {
                  text: 'ㅤㅤㅤ',
                  decoration: 'underline'
                }
              ]
            },
            {
              text: '',
              margin: [0, 0, 0, 20]
            }
          ],
          [
            {
              text: [
                'Before me :',
                {
                  text: 'ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤ',
                  decoration: 'underline'
                }
              ]
            },
            {
              text: [
                {
                  text: 'ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤ',
                  decoration: 'underline'
                },
              ],
              margin: [10, 0, 0, 0]
            }
          ],
          [
            {
              text: 'NAME OF JUSTICE OF THE PEACE',
              fontSize: '9',
              margin: [70, 0, 0, 20]
            },
            {
              text: 'Signature of WITNESS',
              alignment: 'center',
              fontSize: '9'
            }
          ],
          [
            {
              text: [
                {
                  text: 'ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤ',
                  decoration: 'underline'
                }
              ]
            },
            {
              text: ''
            }
          ],
          [
            {
              text: 'Signature of JUSTICE OF THE PEACE',
              margin: [0, 0, 0, 20]
            },
            {
              text: ''
            }
          ]
        ],
      },

      layout: {
        hLineWidth: function (i, node) {
          return 0;
        },
        vLineWidth: function(i, node) {
          return (i > 0 && i < node.table.widths.length) ? 0.2 : 0;
        },
        hLineColor: function (i, node) {
          return 'black';
        }
      }
    }
  ];

  let config = {
    info: {
      title: 'Power Of Attorney',
      modDate: new Date(), // date the document was last modified
      creationDate: new Date(), // date the document was created
      keywords: 'power of attorney, loan, finance', // keywords associated with the document
      author: 'Sodality Co-operative Credit Union Limited', // company name
      subject: 'Power of Attorney', // name of the document being printed
      creator: 'John Doe', // name of the logged in user
      producer: 'Sodality Co-operative Credit Union Limited' // company name
    },

    defaultStyle: {
      font: 'Lora',
      color: '#0f172a',
      fontSize: 11,
      lineHeight: 1.3
    },

    content: [
      {
        text:  `${companyName}`,
        alignment: 'center'
      },
      {
        text: 'POWER OF ATTORNEY',
        alignment: 'center'
      },
      {
        margin: [0, 10, 0, 10],
        table: {
          widths: ['*', '*'],
          body: [
            [
              {
                text: [
                  'BRANCH:',
                  {
                    text: ` ${branch}`,
                    bold: true
                  }
                ]
              },
              {
                text: [
                  'ACCOUNT#:',
                  {
                    text: ` ${accountNumber}`,
                    bold: true
                  }
                ]
              }
            ],
            [
              {
                text: [
                  'LOAN PRODUCT:',
                  {
                    text: ` ${loan.loanProduct}`,
                    bold: true
                  }
                ]
              },
              {
                text: [
                  'LOAN AMOUNT: ',
                  {
                    text: `${totalLoanInWords} (${totalLoan})`,
                    bold: true
                  }
                ]
              }
            ]
          ]
        },
        layout: {
          // default border settings
          hLineWidth: function(i, node) {
            return 0
          },
          vLineWidth: function(i, node) {
            return 0
          },
        }
      },
      {
        text: `I/We, DO HEREBY APPOINT ${companyName}, a Co-operative Society duly incorporated under the Co-operative Societies Act of Jamaica with principal offices at 66 Slipe Road, Kingston 5, in the parish of St. Andrew TO BE MY ATTORNEY and for me/us and in my/our name(s) to perform the following acts:`,
        margin: [0, 0, 0, 10]
      },
      {
        ol: [
          [
            'To Carry into effect and perform all agreements entered or that may be entered into or carry out any act or deed in respect of my motor vehicle particularized below:',
            ...motorVehicleCollaterals
          ],
          [
            {
              text: 'To concur in doing the acts and things herein mentioned in conjunction with any other interested in the said motor vehicle(s);',
              margin: [0, 0, 0, 5]
            }
          ],
          [
            {
              text: 'Also to invest pay or otherwise use any monies received in connection with the said motor vehicle(s) by my Attorney and on my behalf in such securities or investments as my Attorney shall think fit;',
              margin: [0, 0, 0, 5]
            }
          ],
          [
            {
              text: 'Also, to commence, carry on or defend all actions and other proceedings relating to the said motor vehicle(s);',
              margin: [0, 0, 0, 5]
            }
          ]
        ]
      },
      {
        text: 'GENERALLY, also to act in relation to the said motor vehicle(s) owned by me/us as full and in all respects as I/We could do.',
        margin: [0, 0, 0, 10]
      },
      {
        text: 'ALSO, to do the foregoing on my/our behalf and in my/our name(s) or in the name of my/our Attorney as my/our said Attorney shall think fit.',
        margin: [0, 0, 0, 10]
      },
      {
        text: 'AND I/We DO HEREBY UNDERTAKE to ratify everything which my/our Attorney shall do by virtue of these presents AND I/We DECLARE that this Power of Attorney shall be irrevocable from the date hereof.',
        margin: [0, 0, 0, 10],
        pageBreak: 'after'
      },
    ]
  };
  config.content = config.content.concat(useJP ? externalSignatureClause : internalSignatureClause)
  return config
};
